import { Grid } from '@chatterbug/aaron'
import React from 'react'

export type Props = {
  titleSection: JSX.Element
  goalSection: JSX.Element
}

const GoalSettingSkeleton: React.FC<Props> = ({
  titleSection,
  goalSection,
}) => {
  return (
    <Grid gap={{ _: '2x', tablet: '3x' }}>
      {titleSection}
      {goalSection}
    </Grid>
  )
}

export default GoalSettingSkeleton
